var Notifications = (function () {
  var showUrl,
    readUrl,
    tableId;

  function init() {
    showUrl = Url.action('api/notifications/{0}');
    readUrl = Url.action('api/notifications/read');
    tableId = '#NotificationsListItemViewModelTable';

    $(document).ready(function () {
      $(tableId).on('draw.dt', function () {
        var table = $(tableId).DataTable();

        table.rows().data().each(function (row, idx) {
          if (!row.ReadedOn) {
            $($('tbody tr', tableId)[idx]).addClass('text-bold');
          }
        });
      }); 
    })
    .on('click', '#readed', function () {
      var control = $(this);
      $.ajax({
        url: readUrl,
        type: 'POST',
        data: {
          id: control.data('id')
        }
      })
      .success(function (result) {
        $(tableId).DataTable().ajax.reload(null, false);
        $('#newNotifications').html(result && result > 0 ? '<span class="label label-warning">' + result + '</span>' : '');
      })
      .error(function (xhr, status, statusCode) {
        console.error(status + ': ' + statusCode);
      });

      control.closest('.modal').modal('hide');
    });
  }

  function show(id) {
    Popups.showPopup(showUrl.format(id), {}, $('#object-show-content'), $('#object-show'), function (result) { });
  }

  return {
    init: init,
    show: show
  };
})()
